<template>
  <div class="home__column-full">

    <div class="card-grid">

      <div class="card-grid__col"
        v-for="post in this.posts"
        :key="post.id"
      >

        <div class="pick-post-card card-grid__item">
          <div class="pick-post-card__meta">
              <div class="post-meta">
                {{post.date}}
                &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
                  <a
                    :v-if="post.category"
                    :href="post.category.link"
                    class="post-meta__category"
                  >
                    {{post.category.name}}
                  </a>
              </div>
          </div>
          <a
            class="pick-post-card__link"
            :href="post.link"
          >
            <div class="pick-post-card__title" v-html="post.title"></div>
            <div
              class="pick-post-card__image"
              :style="{ backgroundImage: 'url(' + post.image + ')' }"
            >
            </div>

            <p class="pick-post-card__excerpt" v-html="post.excerpt"></p>

            <div class="pick-post-card__cta">
              <div class="link-with-icon">
                {{translate('Lue lisää')}}
                <div class="link-with-icon__icon">
                    <ArrowIcon />
                </div>
              </div>
            </div>
          </a>
        </div>

      </div>

  </div>

  <LoadSpinner
    v-if="loading"
    class="posts__load-more__loading"
  />

  <div
      v-if="!loading"
      class="posts__load-more-container"
  >
    <button
      class="btn"
      @click="loadMore"
    >
      {{translate('Lataa lisää ajankohtaisia')}}
    </button>
  </div>

  </div>
</template>


<script>
  import axios from 'axios';
  import utils from './mixins/utils';
  import globals from '../lib/globals';
  import ArrowIcon from './icons/ArrowIcon.vue';
  import LoadSpinner from './components/LoadSpinner';
  import {DateTime} from 'luxon';

  export default {
    components: {
      ArrowIcon,
      LoadSpinner,
    },
    mixins: [
        utils.translate,
    ],
    props: {
        initialPosts: {
            type: Array,
            required: true,
        },

    },
    data() {
      return {
        loading: false,
        posts: [],
        page: 1,
        perPage : 0,
        totalPages: null,
        offset: 0
      }
    },
    computed: {

    },
    methods: {
      checkImage(p) {
        if(!p._embedded["wp:featuredmedia"]) return;

        if(p._embedded["wp:featuredmedia"][0].media_details.sizes.large) {
          return p._embedded["wp:featuredmedia"][0].media_details.sizes.large.source_url;
        }
        if(p._embedded["wp:featuredmedia"][0].media_details.sizes.medium_large) {
          return p._embedded["wp:featuredmedia"][0].media_details.sizes.medium_large.source_url;
        };
        if(p._embedded["wp:featuredmedia"][0].media_details.sizes.medium) {
          return p._embedded["wp:featuredmedia"][0].media_details.sizes.medium.source_url;
        }
        return null;
      },

      async loadMore() {
        this.loading = true;

        if(this.page === 1) {
          this.perPage = 14;
        } else {
          this.perPage = 6;
        }

        const url = `${globals.urlHome}/wp-json/wp/v2/posts?_embed&per_page=${this.perPage}&offset=${this.offset}`;

        const response = await axios.get(url);

        this.totalPages = response.headers["x-wp-totalpages"];

        if(this.page === 1) {
          response.data.splice(0,5);
        }

        const posts = response.data.map(post => {
          return {
            id: post.id,
            title: post.title.rendered,
            excerpt: post.excerpt.rendered,
            date: DateTime.fromISO(post.date).toFormat('d.M.yyyy H:mm'),
            slug: post.slug,
            link: post.link,
            image: this.checkImage(post),
            category: post._embedded["wp:term"]?.[0][0] ?? '',
          }
        });


        this.posts = [...this.posts, ...posts]

        this.page = this.page + 1;
        this.offset = this.offset + this.perPage;

        this.loading = false;
      },

    },
    async mounted() {
      this.loadMore();
    },
}
</script>

<style lang="scss">
  @import "~styles/definitions";


  .posts__load-more__loading {
    height: r(128);
  }

  .posts__load-more-container {
    display: flex;
    justify-content: center;
    margin-top: r(48);
    margin-bottom: r(48);
  }

</style>
